import { render, staticRenderFns } from "./IconProjectMemberRole.vue?vue&type=template&id=ad1d0d70&scoped=true&"
import script from "./IconProjectMemberRole.vue?vue&type=script&lang=js&"
export * from "./IconProjectMemberRole.vue?vue&type=script&lang=js&"
import style0 from "./IconProjectMemberRole.vue?vue&type=style&index=0&id=ad1d0d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1d0d70",
  null
  
)

export default component.exports